export const PayPalCurrencies = {
    'AUD': {
        name: 'Australian Dollar',
        symbol: 'A$',
        fixed_fee: 0.59,
    },
    'BRL': {
        name: 'Brazilian Real',
        symbol: 'R$',
        fixed_fee: 2.90,
    },
    'CAD': {
        name: 'Canadian Dollar',
        symbol: 'C$',
        fixed_fee: 0.59,
    },
    'CZK': {
        name: 'Czech Koruna',
        symbol: 'Kč',
        fixed_fee: 9.00,
    },
    'DKK': {
        name: 'Danish Krone',
        symbol: 'Kr.',
        fixed_fee: 2.90,
    },
    'EUR': {
        name: 'Euro',
        symbol: '€',
        fixed_fee: 0.39,
    },
    'HKD': {
        name: 'Hong Kong Dollar',
        symbol: 'HK$',
        fixed_fee: 3.79,
    },
    'HUF': {
        name: 'Hungarian Forint',
        symbol: 'Ft',
        fixed_fee: 149.00,
    },
    'ILS': {
        name: 'Israeli New Shekel',
        symbol: '₪',
        fixed_fee: 1.60,
    },
    'JPY': {
        name: 'Japanese Yen',
        symbol: '¥',
        fixed_fee: 49.00,
    },
    'MYR': {
        name: 'Malaysian Ringgit',
        symbol: 'RM',
        fixed_fee: 2.00,
    },
    'MXN': {
        name: 'Mexican Peso',
        symbol: 'Mex$',
        fixed_fee: 9.00,
    },
    'NOK': {
        name: 'Norwegian Krone',
        symbol: 'kr',
        fixed_fee: 3.90,
    },
    'NZD': {
        name: 'New Zealand Dollar',
        symbol: 'NZD$',
        fixed_fee: 0.69,
    },
    'PHP': {
        name: 'Philippine Peso',
        symbol: '₱',
        fixed_fee: 25.00,
    },
    'PLN': {
        name: 'Polish Zloty',
        symbol: 'zł',
        fixed_fee: 1.89,
    },
    'GBP': {
        name: 'UK Pounds Sterling',
        symbol: '£',
        fixed_fee: 0.39,
    },
    'RUB': {
        name: 'Russian Ruble',
        symbol: '₽',
        fixed_fee: 39.00,
    },
    'SGD': {
        name: 'Signapore Dollar',
        symbol: 'S$',
        fixed_fee: 0.69,
    },
    'SEK': {
        name: 'Swedish Krona',
        symbol: 'kr',
        fixed_fee: 4.09,
    },
    'CHF': {
        name: 'Swiss Franc',
        symbol: 'CHF',
        fixed_fee: 0.49,
    },
    'TWD': {
        name: 'New Taiwan Dollar',
        symbol: 'NT$',
        fixed_fee: 14.00,
    },
    'THB': {
        name: 'Thai Baht',
        symbol: '฿',
        fixed_fee: 15.00,
    },
    'USD': {
        name: 'U.S. Dollar',
        symbol: '$',
        fixed_fee: 0.49,
    }
};
